module.exports = __webpack_public_path__ + "static/img/img3.8de0076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/img3.png
// module id = Z+7D
// module chunks = 0